import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { defaultBorrowerLegalName } from '../../components/loan_application/form_models/constants';
import {
  genericRequiredFieldError,
  SYSTEM_POWER_USAGE_TYPE,
  SYSTEM_POWER_USAGE_VALUES,
} from '../../constants';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';

const {
  formField: { systemPowerUsage, systemPowerSingleOrMultipleUsers },
} = loanFormModel;

export class SingleOrMultipleUsersValidation implements ValidationSchema {
  public name: string = systemPowerSingleOrMultipleUsers.name;
  public label: string = systemPowerSingleOrMultipleUsers.getLabel(
    defaultBorrowerLegalName
  );
  public dependsOn: string[] = [systemPowerUsage.name];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(systemPowerUsage: SYSTEM_POWER_USAGE_TYPE, schema) {
    if (systemPowerUsage === SYSTEM_POWER_USAGE_VALUES.SOLD_TO_ANOTHER_ENTITY) {
      return schema.required(genericRequiredFieldError);
    }
    return schema;
  }
}
export default new Validation(new SingleOrMultipleUsersValidation());
